import { Checkbox } from "@/components/ui/checkbox";

export function PageToggles({ pages, value, onChange, disabled, idPrefix = "page-toggle" }) {
  const toggle = (key) => {
    if (value.includes(key)) onChange(value.filter((k) => k !== key));
    else onChange([...value, key]);
  };
  return (
    <div className="grid grid-cols-2 gap-2">
      {pages.map((p) => (
        <label key={p.key} className={`flex items-center gap-2 text-sm rounded-md border px-2.5 py-2 ${disabled ? "opacity-50" : "cursor-pointer hover:bg-slate-50"} ${value.includes(p.key) ? "border-sky-500 bg-sky-50/50" : "border-slate-200"}`}>
          <Checkbox checked={value.includes(p.key)} onCheckedChange={() => !disabled && toggle(p.key)} disabled={disabled} data-testid={`${idPrefix}-${p.key}`} />
          <span className="text-slate-700">{p.label}</span>
        </label>
      ))}
    </div>
  );
}
